import {FiPlus} from "react-icons/fi";
import {RevealAnimation} from "../../animations/RevealAnimation";
import {EXPERIENCE} from "../../data/resume";

const FEATURED_BULLET_INDEXES = [0, 1, 2, 3, 5];

export const ExperienceSection = () => {
    const [currentRole, ...earlierRoles] = EXPERIENCE;
    const featuredBullets = FEATURED_BULLET_INDEXES.map(index => currentRole.bullets[index]);

    return (
        <section id="experience" className="section shell" aria-labelledby="experience-title">
            <RevealAnimation>
                <div className="section-heading">
                    <h2 id="experience-title">Experience<span className="accent-dot">.</span></h2>
                    <p>Founding-stage ownership today, backed by 9+ years across product teams, fintech, and independent delivery.</p>
                </div>

                <article className="featured-experience">
                    <div className="experience-heading">
                        <div>
                            <p className="experience-kicker">Current role</p>
                            <h3>{currentRole.role}</h3>
                            <p className="experience-company">{currentRole.company}</p>
                        </div>
                        <p className="experience-period">{currentRole.period}</p>
                    </div>
                    <p className="experience-summary">{currentRole.summary}</p>
                    <ul>
                        {featuredBullets.map(bullet => (
                            <li key={bullet.label}>
                                <strong>{bullet.label}</strong>
                                <span>{bullet.body}</span>
                            </li>
                        ))}
                    </ul>
                </article>

                <div className="earlier-experience">
                    <h3>Earlier roles</h3>
                    {earlierRoles.map(role => (
                        <details key={role.id} className="earlier-role">
                            <summary>
                                <span className="earlier-role-title"><strong>{role.company}</strong><span>{role.role}</span></span>
                                <span className="earlier-role-meta"><span>{role.period}</span><FiPlus aria-hidden="true" /></span>
                            </summary>
                            <div className="earlier-role-body">
                                <p>{role.summary}</p>
                                <ul>
                                    {role.bullets.map(bullet => <li key={bullet.label}><strong>{bullet.label}:</strong> {bullet.body}</li>)}
                                </ul>
                            </div>
                        </details>
                    ))}
                </div>
            </RevealAnimation>
        </section>
    );
};
